<div class='line'>
  <span class='company-name color-gray-3' *ngIf='companyName'> {{ companyName }}: </span>
  <span class='address' *ngIf='address'>
    <span class='address-item city'> {{ address.city }}</span>
    <span class='comma' *ngIf='address.city'>, </span>
    <span class='address-item address-line'> {{ address.addressLine }}</span>
    <span class='comma' *ngIf='address.block'>, </span>
    <span class='address-item city' *ngIf='address.block'>Bl. {{ address.block }}</span>
    <span class='comma' *ngIf='address.building'>, </span>
    <span class='address-item city' *ngIf='address.building'>Sc. {{ address.building }}</span>
    <span class='comma' *ngIf='address.floor'>, </span>
    <span class='address-item city' *ngIf='address.floor'>Et. {{ address.floor }}</span>
    <span class='comma' *ngIf='address.apartment'>, </span>
    <span class='address-item city' *ngIf='address.apartment'>Ap. {{ address.apartment }}</span>
    <span class='comma' *ngIf='address.postalCode'>, </span>
    <span class='address-item postalCode'> {{ address.postalCode }}</span>
    <span class='comma' *ngIf='address.state'>, </span>
    <span class='address-item state'> {{ address.state }}</span>
    <span class='comma' *ngIf='address.country'>, </span>
    <span class='address-item country'> {{ address.country }}</span>
  </span>
</div>


